import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import {
  Buttons,
  Spacer,
  boxContainer,
  questionnaireComponents,
  inputFields,
  checkbox,
} from "..";

import "./styles.css";

const ContactProfileBuilder = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const [same, setSame] = useState(false);
  const [contacts, setContacts] = useState({
    emergencyName: "",
    emergencyRelation: "",
    emergencyEmail: "",
    emergencyPhone: "",
    guardianName: "",
    guardianRelation: "",
    guardianEmail: "",
    guardianPhone: "",
  });

  useEffect(() => {
    setContacts({
      emergencyName: questionnaire?.emergencyName,
      emergencyRelation: questionnaire?.emergencyRelation,
      emergencyEmail: questionnaire?.emergencyEmail,
      emergencyPhone: questionnaire?.emergencyPhone,
      guardianName: questionnaire?.guardianName,
      guardianRelation: questionnaire?.guardianRelation,
      guardianEmail: questionnaire?.guardianEmail,
      guardianPhone: questionnaire?.guardianPhone,
    });
    if (
      questionnaire?.emergencyName &&
      questionnaire?.emergencyName === questionnaire?.guardianName &&
      questionnaire?.emergencyRelation &&
      questionnaire?.emergencyRelation === questionnaire?.guardianRelation &&
      questionnaire?.emergencyEmail === questionnaire?.guardianEmail &&
      questionnaire?.emergencyPhone &&
      questionnaire?.emergencyPhone === questionnaire?.guardianPhone
    ) {
      setSame(true);
    }
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      <div>
        <div className="section-header">Emergency Contact</div>
        <div className="grid grid-cols-2 gap-x-7 gap-y-6">
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Name" required />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.emergencyName}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel
              text="Relation"
              required
            />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.emergencyRelation}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Email" />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.emergencyEmail}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel
              text="Phone Number"
              required
            />
            <Spacer height="0.3125em" />
            <inputFields.DefaultPhoneInput
              disabled
              value={contacts?.emergencyPhone}
            />
          </div>
        </div>
      </div>

      <Spacer height="1.25em" />
      <div>
        <div className="section-header">Guardian</div>
        <div className="grid grid-cols-2 gap-x-7 gap-y-6">
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Name" />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.guardianName}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Relation" />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.guardianRelation}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Email" />
            <Spacer height="0.3125em" />
            <questionnaireComponents.QuestionnaireValueBox
              value={contacts.guardianEmail}
            />
          </div>
          <div>
            <questionnaireComponents.QuestionnaireLabel text="Phone Number" />
            <Spacer height="0.3125em" />
            <inputFields.DefaultPhoneInput
              disabled
              value={contacts?.guardianPhone}
            />
          </div>
        </div>
        <Spacer height="0.3125em" />
        <checkbox.DefaultCheckbox
          text="Same as emergency contact"
          checked={same}
          disabled
        />
      </div>
      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Counselor")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default ContactProfileBuilder;
